
















































































import {
  computed, defineComponent, PropType, ref, watch,
} from 'vue';

import api from '@/api';
import store from '@/store';

import { randomPhrase } from '@/utils/randomPhrase';

export default defineComponent({
  props: {
    somethingChecked: {
      type: Boolean as PropType<boolean>,
      required: true,
    },

    selection: {
      type: Array as PropType<string[]>,
      required: true,
    },
  },

  setup(props, { emit }) {
    const dialog = ref(false);
    const confirmationPhrase = ref('');
    const confirmation = ref('');

    const plural = computed(() => (props.selection.length > 1 ? 's' : ''));
    const detail = computed(() => (props.selection.length === 1 ? ` (${props.selection[0]})` : ''));

    async function execute() {
      await Promise.all(props.selection.map((ws) => api.deleteWorkspace(ws)));

      store.dispatch.fetchWorkspaces();
      emit('deleted');

      dialog.value = false;
    }

    function clear() {
      confirmationPhrase.value = '';
      confirmation.value = '';
    }

    watch(dialog, () => {
      if (dialog.value) {
        clear();
        confirmationPhrase.value = randomPhrase();
      } else {
        emit('closed');
      }
    });

    return {
      dialog,
      confirmationPhrase,
      confirmation,
      plural,
      detail,
      execute,
    };
  },
});
